<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title>Atenção!</h2>
  </div>
  <div class="dialog-content">

    <p>Não é possível criar um novo acordo, pois os preços dos combustíveis não estão cadastrados ou estão
      desatualizados.
      Por favor, <strong>cadastre ou atualize os
        preços</strong>
      antes de criar um novo acordo.
    </p>
  </div>
  <div class="dialog-footer">
    <div class="col-12 text-end">
      <button mat-button class="btn-fundo-vermelho" (click)="fecharModal()">
        Fechar
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
</div>